import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const faqData = [
  // Tarifs et engagement
  {
    question: "Combien coûte Piktable ?",
    answer: "49 CHF par mois sur l'offre Standard, ou 29 CHF par mois à vie pour les 50 premiers restaurants qui rejoignent l'offre de Printemps 2026. Aucune commission par couvert, quelle que soit ta fréquentation. La facturation est annuelle, résiliable à tout moment avec remboursement au prorata de la part non utilisée."
  },
  {
    question: "Qu'est-ce que l'offre de Printemps 2026 ?",
    answer: "C'est notre offre fondateur, limitée aux 50 premiers restaurants qui rejoignent Piktable avant le 30 septembre 2026. Tu verrouilles le tarif à 29 CHF par mois à vie (jamais d'augmentation), tu obtiens 60 jours d'essai au lieu de 30, le logo « Restaurant Fondateur » sur piktable.ch, un accès prioritaire aux nouvelles fonctionnalités et 1 h de coaching à la mise en ligne. Une fois les 50 places prises, l'offre se ferme définitivement."
  },
  {
    question: "Y a-t-il une commission par couvert ?",
    answer: "Non, jamais. Contrairement à des plateformes comme TheFork, nous ne prenons aucun pourcentage sur tes réservations. Tu paies un abonnement fixe et prévisible, sans surprise. C'est l'une de nos quatre garanties officielles : Zéro Commission, pour toujours."
  },
  {
    question: "Puis-je essayer Piktable gratuitement ?",
    answer: "Oui : 30 jours sur l'offre Standard, 60 jours sur l'offre de Printemps 2026 et l'offre École Hôtelière. Sans carte bancaire, sans engagement. Tu configures ton espace et tu testes toutes les fonctionnalités sans limite."
  },
  {
    question: "Puis-je résilier en cours d'année ?",
    answer: "Oui, à tout moment et sans justification. La facturation est annuelle, mais si tu pars en cours d'année, on te rembourse la part non utilisée au prorata. Tes données restent les tiennes : tu peux les exporter librement à tout moment au format CSV."
  },
  {
    question: "Comment fonctionne le parrainage ?",
    answer: "En présentant des restaurateurs qui prennent rendez-vous avec nous, ton tarif baisse automatiquement et définitivement. 1 restaurateur parrainé : 39 CHF par mois. 2 parrainés : 34 CHF. 3 parrainés : 29 CHF par mois à vie. Les réductions sont cumulables et verrouillées pour toujours, même si nos prix publics évoluent."
  },
  {
    question: "Et si je trouve moins cher ailleurs ?",
    answer: "C'est notre garantie Meilleur Prix. Si tu trouves un outil équivalent (sans commission, fonctionnalités comparables) à un tarif plus bas, envoie-nous l'offre par email. On s'aligne, point. C'est l'une de nos quatre garanties officielles."
  },
  {
    question: "Existe-t-il une offre pour les écoles hôtelières ?",
    answer: "Oui. Nous proposons une offre dédiée aux écoles hôtelières et à leurs restaurants d'application : 60 jours gratuits, tarif préférentiel et accompagnement à la mise en route. Détails sur la page « Offre École Hôtelière » du site."
  },

  // Mise en route et accompagnement
  {
    question: "Combien de temps faut-il pour être opérationnel ?",
    answer: "En autonomie, compte environ 30 minutes : un parcours d'onboarding guidé t'aide à configurer tes horaires, tes zones, tes tables et ton widget de réservation. Si tu préfères qu'on s'en occupe à ta place, l'option d'activation accompagnée à 100 CHF (facturée une seule fois, entièrement remboursable si tu ne poursuis pas l'abonnement) couvre la migration de tes données, le plan de salle, les créneaux et la pose du widget sur ton site."
  },
  {
    question: "Puis-je importer mes clients existants ?",
    answer: "Oui. Tu peux importer ta base clients par fichier CSV depuis le dashboard, et l'exporter à tout moment au même format. Si tu choisis l'activation accompagnée, on s'occupe de la migration pour toi à partir de l'export de ton outil actuel."
  },

  // Fonctionnement au quotidien
  {
    question: "Comment mes clients réservent-ils avec Piktable ?",
    answer: "Tes clients réservent via un widget moderne intégré en une ligne de code sur ton site, ou via une page de réservation publique dédiée (piktable.ch/ton-resto) que tu peux partager sur Instagram, Google ou par email. L'expérience est optimisée pour mobile : choix du nombre de personnes, de la date et de l'heure en quelques clics, avec confirmation immédiate."
  },
  {
    question: "Comment Piktable réduit-il les no-shows ?",
    answer: "Quatre leviers complémentaires : confirmation immédiate par email, rappel automatique J-1, suivi 4h après la visite (avec invitation à laisser un avis Google), et statuts clients (no-show, blacklist, VIP) qui s'enrichissent automatiquement à chaque réservation. Tu vois en un coup d'œil les clients à risque et tu protèges ta salle."
  },
  {
    question: "Sur quels appareils Piktable fonctionne-t-il ?",
    answer: "Piktable est un outil web : il tourne sur tout navigateur récent (ordinateur, tablette, smartphone). Il s'installe aussi en application mobile (PWA) sur iPhone et Android, sans passer par les stores. Plusieurs membres de l'équipe peuvent l'utiliser en même temps, avec des comptes staff distincts et des rôles séparés (admin / staff)."
  },
  {
    question: "Piktable gère-t-il les terrasses, zones et grands groupes ?",
    answer: "Oui. Tu configures plusieurs zones (salle, terrasse, bar, salon privé) avec leurs propres tables. Tes clients voient les disponibilités selon leur préférence, et tu peux fermer la terrasse indépendamment du reste selon la météo. Pour les grands groupes, Piktable combine automatiquement plusieurs tables et propose une configuration de contact dédiée au-delà d'un seuil que tu fixes."
  },
  {
    question: "Envoyez-vous des SMS aux clients ?",
    answer: "Les confirmations et rappels sont envoyés par email, inclus sans surcoût et sans limite. L'envoi de SMS est disponible en option pour les restaurants qui le souhaitent : facturation à l'usage, activable depuis les réglages."
  },

  // Confiance et données
  {
    question: "Où sont hébergées mes données ?",
    answer: "Piktable est conçu à Lausanne, et tes données sont hébergées sur des serveurs sécurisés en Suisse ou dans l'Union européenne, conformes à la nLPD suisse et au RGPD. Chiffrement, authentification sécurisée et sauvegardes automatiques garantissent la protection de tes informations. Tes données t'appartiennent : tu peux les exporter librement à tout moment."
  },
  {
    question: "Proposez-vous un support en français ?",
    answer: "Oui. Notre équipe est basée à Lausanne et le support est entièrement en français, dans ton fuseau horaire. Tu peux nous joindre par email, via le formulaire de contact ou via le bouton de feedback intégré dans l'application. Les retours produit sont traités directement par l'équipe qui développe Piktable."
  },
  {
    question: "Quelle est la différence entre Piktable et une marketplace comme TheFork ?",
    answer: "Piktable est un outil de gestion, pas une marketplace. Nous ne t'amenons pas de clients : ce sont les tiens, via ton site, Instagram, Google ou le bouche-à-oreille. Nous t'aidons à les gérer sereinement. Tu gardes le contrôle total sur ta relation client et tes données. Pas de commission par couvert, jamais. Pas de mise en avant payante de tes concurrents sur ta propre fiche."
  }
];

const FAQ = () => {
  const faqs = faqData;

  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-foreground mb-4">
              Questions fréquentes
            </h2>
            <p className="text-xl text-muted-foreground">
              Tout ce que tu dois savoir sur Piktable
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-lg px-6"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="font-semibold text-lg text-foreground pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
